import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Story from "@/pages/Story";
import Book from "@/pages/Book";
import Admin from "@/pages/Admin";
import { Gift, GiftSuccess } from "@/pages/Gift";
import { Merch, MerchSuccess } from "@/pages/Merch";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/story" element={<Story />} />
          <Route path="/book" element={<Book />} />
          <Route path="/gift" element={<Gift />} />
          <Route path="/gift/success" element={<GiftSuccess />} />
          <Route path="/merch" element={<Merch />} />
          <Route path="/merch/success" element={<MerchSuccess />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
